import { render, staticRenderFns } from "./TuNiuConfig.vue?vue&type=template&id=5c0fe56a&scoped=true"
import script from "./TuNiuConfig.vue?vue&type=script&lang=js"
export * from "./TuNiuConfig.vue?vue&type=script&lang=js"
import style0 from "./TuNiuConfig.vue?vue&type=style&index=0&id=5c0fe56a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0fe56a",
  null
  
)

export default component.exports